import Ratings from './Ratings'
import RatingsSfra from './ratings-sfra/RatingsSfra'

export {Ratings, RatingsSfra}
